<template>
  <div>
    <Loader v-if="carregando" />
    <div class="container"><div class="page-inner">
      <div v-if="editView" class="page-header gp-admin-page-heading">
        <h3 class="fw-bold">{{ formulario.stcId ? 'Alterar categoria de chamado' : 'Nova categoria de chamado' }}</h3>
        <ul class="breadcrumbs">
          <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
          <li class="separator"><i class="fa fa-chevron-right"></i></li>
          <li class="nav-item"><a href="#" @click.prevent="cancelar">Cadastro de categorias de chamados</a></li>
          <li class="separator"><i class="fa fa-chevron-right"></i></li>
          <li class="nav-item"><span>{{ formulario.stcId ? 'Alterar' : 'Novo cadastro' }}</span></li>
        </ul>
      </div>
      <div v-if="erroCarregamento" class="alert alert-danger" role="alert">{{ erroCarregamento }} <button type="button" class="btn btn-outline-secondary btn-sm" @click="carregar">Tentar novamente</button></div>
      <div v-if="editView" class="row">
        <div class="col-md-12"><div class="card">
          <div class="gp-admin-form-header">
            <span><v-icon size="20">mdi-tag-outline</v-icon></span>
            <div><h4>{{ formulario.stcId ? 'Alterar categoria de chamado' : 'Nova categoria de chamado' }}</h4><p>Informe a garantidora e o nome da categoria.</p></div>
          </div>
          <div class="card-body"><div class="row">
            <div class="col-md-6"><div class="form-group">
              <label>Garantidora</label>
              <v-autocomplete v-model="formulario.garId" :items="garantidoras" item-title="garNomeEmpresa" item-value="garId" placeholder="Global — todas as garantidoras" variant="outlined" density="compact" hide-details :clearable="podeSelecionarGarantidora && !formulario.stcId" :disabled="!pronto || !podeSelecionarGarantidora || !!formulario.stcId" />
              <small class="text-muted">{{ podeSelecionarGarantidora ? 'Deixe vazio para uma categoria global.' : 'Vinculada à sua garantidora.' }}</small>
            </div></div>
            <div class="col-md-6"><div class="form-group">
              <label>Nome da categoria *</label>
              <input v-model.trim="formulario.stcNomeTipoChamado" type="text" class="form-control" :disabled="!pronto" placeholder="Informe o nome da categoria" @keyup.enter="salvar" />
            </div></div>
          </div></div>
        </div></div>
        <div class="card-action gp-admin-actions gp-detail-actions">
          <button type="button" class="btn btn-success" :disabled="!pronto || carregando" @click="salvar">{{ formulario.stcId ? 'Alterar' : 'Salvar' }}</button>
          <button type="button" class="btn btn-link" :disabled="carregando" @click="cancelar">Cancelar</button>
        </div>
      </div>
      <div v-else class="row"><div class="col-md-12"><div class="card">
        <div class="card-header"><div class="d-flex align-items-center">
          <h4 class="card-title">Cadastro de categorias de chamados</h4>
          <button type="button" class="btn btn-sm btn-secondary ms-auto" :disabled="!pronto || carregando" @click="novo"><i class="fa fa-plus"></i> Incluir Novo</button>
        </div></div>
        <div class="card-body">
          <adm-data-table :headers="headers" :items="categorias" :filter-columns="3" alternating theme-color="#364f66" table-class-name="customize-table" header-text-direction="center" body-text-direction="center" rows-per-page-message="Linhas por página">
            <template #item-actions="item"><div class="gp-table-actions">
              <button v-if="item.podeEditar" type="button" class="gp-table-action gp-action-edit" title="Editar categoria" @click="editar(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
              <span v-else class="text-muted">Somente leitura</span>
            </div></template>
          </adm-data-table>
        </div>
      </div></div></div>
    </div></div>
  </div>
</template>
<script>
import axios from 'axios'
import Loader from '../../components/PageLoader.vue'
export default {
  name: 'SupTiposChamadosView',
  components: { Loader },
  data: () => ({
    editView: false,
    carregando: false,
    pronto: false,
    erroCarregamento: '',
    podeSelecionarGarantidora: false,
    garId: null,
    garantidoras: [],
    categorias: [],
    formulario: { stcId: 0, garId: null, stcNomeTipoChamado: '' },
    headers: [
      { text: 'Id', value: 'stcId', sortable: true, hideFilter: true },
      { text: 'Garantidora', value: 'garantidoraNome', sortable: true },
      { text: 'Categoria', value: 'stcNomeTipoChamado', sortable: true },
      { text: 'Ações', value: 'actions' }
    ]
  }),
  methods: {
    novo () { if (!this.pronto) return; this.limpar(); this.editView = true },
    cancelar () { this.limpar(); this.editView = false },
    limpar () { this.formulario = { stcId: 0, garId: this.podeSelecionarGarantidora ? null : this.garId, stcNomeTipoChamado: '' } },
    editar (item) { if (!item.podeEditar) return; this.editView = true; this.formulario = { stcId: item.stcId, garId: item.garId, stcNomeTipoChamado: item.stcNomeTipoChamado }; window.scrollTo({ top: 0, behavior: 'smooth' }) },
    async carregar () {
      this.carregando = true
      this.pronto = false
      this.erroCarregamento = ''
      try {
        const { data } = await axios.get('/Telas/ConfiguracoesChamados/GetDados')
        this.garantidoras = data.garantidoras || []
        this.podeSelecionarGarantidora = !!data.podeSelecionarGarantidora
        this.garId = data.garId
        this.categorias = (data.listaTiposChamados || []).map(x => ({ ...x, garantidoraNome: x.garId == null ? 'Global — todas' : this.garantidoras.find(g => g.garId === x.garId)?.garNomeEmpresa || `Garantidora #${x.garId}` }))
        this.limpar()
        this.pronto = true
      } catch (e) {
        this.erroCarregamento = e.response?.status === 403 ? 'Acesso negado ao cadastro de categorias (tela 37). Verifique a permissão do perfil e o vínculo da sessão.' : this.$obterMensagemErro(e)
        if (!e.__gpNotified) this.$mensagemErro(this.erroCarregamento)
      } finally { this.carregando = false }
    },
    async salvar () {
      if (!this.pronto || this.carregando) return
      if (!this.formulario.stcNomeTipoChamado) { this.$mensagemAviso('Informe o nome da categoria.'); return }
      this.carregando = true
      try {
        if (this.formulario.stcId) await axios.put('/Telas/ConfiguracoesChamados/UpdateTiposChamados', this.formulario)
        else await axios.post('/Telas/ConfiguracoesChamados/AddTiposChamados', this.formulario)
        this.$mensagemAvisoSucesso('Categoria salva com sucesso.')
        this.editView = false
        await this.carregar()
      } catch (e) { if (!e.__gpNotified) this.$mensagemErro(this.$obterMensagemErro(e)) } finally { this.carregando = false }
    }
  },
  created () { this.carregar() }
}
</script>
